import { ActionTypes } from "../constants/action-types";
import { fromJS } from "immutable";
import { handleActions } from "redux-actions";

const initialState = fromJS({
  pending: true,
  bucket: {},
  TASK: [],
  SALE: [],
  COMPANY: [],
  CONTACT: [],
  TRACKING: [],
  ACTIVITY: [],
});

export const actions = {
  [ActionTypes.setUpBuckets]: {
    next(state, { payload }) {
      const { type, buckets } = payload;
      const newState = {
        ...state.toJS(),
        [type]: buckets,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.getBuckets]: {
    next(state, data) {
      const { payload, error, pending } = data;
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload === null || payload === undefined) {
        return state;
      }
      const { buckets, type } = payload;
      if (!buckets || !Array.isArray(buckets)) {
        return state;
      }
      const sortedBuckets = [...buckets].sort((a, b) => a.order - b.order);
      const newState = {
        ...state.toJS(),
        [type]: sortedBuckets,
        pending: false,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.saveBucket]: {
    next(state, data) {
      const { payload, error, pending } = data;
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload === null) {
        return state;
      }
      const { id, type, order, setUp } = payload;
      let newList = fromJS([]);
      if (id) {
        newList = state.getIn([type]).set(order, payload);
      } else {
        if (setUp) {
          newList = state.getIn([type]).push({
            ...payload,
            order: state.getIn([type]).size,
            id: `setup-${state.getIn([type]).size}`,
          });
        } else {
          newList = state.getIn([type]).push(payload);
        }
      }
      const newState = {
        ...state.toJS(),
        [type]: newList.toJS(),
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.deleteBucket]: {
    next(state, data) {
      const { payload, error, pending } = data;
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload === null) {
        return state;
      }
      const { bucketId, type } = payload;
      const buckets = state.getIn([type]);
      const newList = buckets.filter((b) => b.get("id") !== bucketId);
      const newState = {
        ...state.toJS(),
        [type]: newList.toJS(),
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.changeBucketOrder]: {
    next(state, data) {
      const { payload, error, pending } = data;
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload === null) {
        return state;
      }
      const { bucketId, direction, type } = payload;
      const buckets = state.getIn([type]);
      const bucketIndex = buckets.findIndex((b) => b.get("id") === bucketId);
      if (bucketIndex === -1) {
        return state;
      }
      const bucket = buckets.get(bucketIndex);
      const currentOrder = bucket.get("order");

      let newList = buckets.toJS();
      let targetIndex;

      if (direction === "up") {
        if (bucketIndex === 0) {
          return state; // Already at top
        }
        targetIndex = bucketIndex - 1;
        const targetBucket = newList[targetIndex];
        // Swap orders
        newList[bucketIndex] = {
          ...newList[bucketIndex],
          order: targetBucket.order,
        };
        newList[targetIndex] = { ...targetBucket, order: currentOrder };
      } else {
        if (bucketIndex === newList.length - 1) {
          return state; // Already at bottom
        }
        targetIndex = bucketIndex + 1;
        const targetBucket = newList[targetIndex];
        // Swap orders
        newList[bucketIndex] = {
          ...newList[bucketIndex],
          order: targetBucket.order,
        };
        newList[targetIndex] = { ...targetBucket, order: currentOrder };
      }

      // Sort by order to ensure correct order
      newList.sort((a, b) => a.order - b.order);

      const newState = {
        ...state.toJS(),
        [type]: newList,
      };
      return fromJS(newState);
    },
  },
};

export const bucketReducer = handleActions(actions, initialState);
